/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, IconButton } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

const parentsProfileTableData = (students, handleStudentEditOpen, handleStudentDeleteOpen) => {
  const displayValue = (val, fallback = "NA") => {
    if (val === null || val === undefined || val === "") return fallback;
    if (typeof val === "object") {
      if (Array.isArray(val)) {
        return val
          .map((v) =>
            v && typeof v === "object" ? v.name || v.title || v._id || JSON.stringify(v) : v
          )
          .join(", ");
      }
      return val.name || val.title || val.boardName || val._id || fallback;
    }
    return val;
  };
  if (students === undefined) {
    return parentsProfileTableData;
  }

  // Create noop functions if handlers not provided
  const onEdit = handleStudentEditOpen || (() => {});
  const onDelete = handleStudentDeleteOpen || (() => {});
  const studentList = Array.isArray(students) ? students : [];
  const rows = studentList.map((student, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.name || "NA"}
      </ArgonTypography>
    ),

    Gender: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.gender || "NA"}
      </ArgonTypography>
    ),
    "Date of Birth": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {new Date(student.dob).toLocaleDateString() || "NA"}
      </ArgonTypography>
    ),
    "School/College/University Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.schoolName || "NA"}
      </ArgonTypography>
    ),
    Class: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {[
          displayValue(student.class || student.standard || student.currentClass, ""),
          displayValue(student.board || student.educationBoard || student.boardName, ""),
          student.subjects && student.subjects.length > 0
            ? student.subjects.map((s) => (s && s.name) || s).join(", ")
            : student.subject
            ? displayValue(student.subject, "")
            : "",
        ]
          .filter(Boolean)
          .join(" | ") || "NA"}
      </ArgonTypography>
    ),
    "Preferred Time Duration": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.preferredTimeDuration || "NA"} mins
      </ArgonTypography>
    ),
    "Tuition Tenure": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.noOfClassesPerWeek || "NA"} classes/week
      </ArgonTypography>
    ),
    "mode Of Tuition": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student.modeOfTuition || "NA"}
      </ArgonTypography>
    ),
    "Tuition Preferred Location": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {displayValue(student.tutionPreferedLocation) || "NA"}
      </ArgonTypography>
    ),
    Action: (
      <ArgonBox display="flex" gap={1}>
        <IconButton
          onClick={() => onEdit(student)}
          size="small"
          sx={{
            color: "#667eea",
            "&:hover": { backgroundColor: "rgba(102, 126, 234, 0.1)" },
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>

        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            console.log("delete button clicked", student?._id);
            onDelete(student);
          }}
          size="small"
          sx={{
            color: "#ff4d4f",
            "&:hover": { backgroundColor: "rgba(255, 77, 79, 0.08)" },
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </ArgonBox>
    ),
    // "Tutors Level": (
    //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
    //     {student.currentSubscription?.tutorAccess || "N/A"}
    //   </ArgonTypography>
    // ),
  }));

  return {
    columns: parentsProfileTableData.columns,
    rows,
  };
};

parentsProfileTableData.columns = [
  { name: "sno", align: "center" },
  { name: "student Name", align: "left" },
  { name: "Gender", align: "left" },
  { name: "Date of Birth", align: "left" },
  { name: "School/College/University Name", align: "left" },
  { name: "Class", align: "left" },
  { name: "Preferred Time Duration", align: "left" },
  { name: "Tuition Tenure", align: "left" },
  { name: "Tuition Preferred Location", align: "left" },
  { name: "mode Of Tuition", align: "center" },
  { name: "Action", align: "center" },
  // { name: "Tutors Level", align: "left" },
];

parentsProfileTableData.rows = [
  {
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {1}
      </ArgonTypography>
    ),
    "student Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        Arun Yadav
      </ArgonTypography>
    ),
    Gender: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Male"}
      </ArgonTypography>
    ),
    "Date of Birth": (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {"01-01-2000"}
      </ArgonTypography>
    ),
    "School/College/University Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"ABC University"}
      </ArgonTypography>
    ),
    Class: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"10th"}
      </ArgonTypography>
    ),
    Board: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"CBSE"}
      </ArgonTypography>
    ),
    "Preferred Time Duration": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Morning"}
      </ArgonTypography>
    ),
    "Tuition Tenure": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {" 1 year"}
      </ArgonTypography>
    ),

    "mode Of Tuition": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Online"}
      </ArgonTypography>
    ),
    "Tutors Level": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {"Intermediate"}
      </ArgonTypography>
    ),
  },
];

export default parentsProfileTableData;
